import { render, staticRenderFns } from "./wizardContentManagement.vue?vue&type=template&id=77f70334&scoped=true&"
import script from "./wizardContentManagement.vue?vue&type=script&lang=js&"
export * from "./wizardContentManagement.vue?vue&type=script&lang=js&"
import style0 from "./wizardContentManagement.vue?vue&type=style&index=0&id=77f70334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f70334",
  null
  
)

export default component.exports